var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#353333",
    d: "M5.598 1.6v1.6h4.8V1.6h.8v1.6h2.4v11.2h-11.2V3.2h2.4V1.6zm7.2 4.8h-9.6v7.2h9.6zm0-2.4h-9.6v1.6h9.6z"
  })));
};
export default SvgCalendar;